import { render, staticRenderFns } from "./VehicleImport.vue?vue&type=template&id=0c460ac4"
import script from "./VehicleImport.vue?vue&type=script&lang=js"
export * from "./VehicleImport.vue?vue&type=script&lang=js"
import style0 from "./VehicleImport.vue?vue&type=style&index=0&id=0c460ac4&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports